/*
  PBM header redesign (OPP header plan, 2026-10-24), H3: the desktop "Account & Lists" flyout
  (snippets/pbm-hdr-actions.liquid). Loaded by sections/header-search-focus.liquid while "PBM header" is on.
  - Mouse: opens 120 ms after the pointer enters the block, closes 250 ms after it leaves (block + flyout).
  - Caret button: click, Enter or Space toggles; aria-expanded follows.
  - Escape closes and puts focus back on the caret; focus or a click outside closes it.
  - Touch screens without hover (tablets): the first tap on "Account & Lists" opens the flyout, the next one follows the link.
*/
(function () {
  var root = document.querySelector('[data-pbm-acct]');
  if (!root) return;
  var toggle = root.querySelector('[data-pbm-acct-toggle]');
  var link = root.querySelector('[data-pbm-acct-link]');
  var openTimer = null, closeTimer = null;
  var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function isOpen() { return root.classList.contains('is-open'); }
  function setOpen(on) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    root.classList.toggle('is-open', on);
    if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  root.addEventListener('mouseenter', function () {
    if (noHover) return;
    clearTimeout(closeTimer);
    if (!isOpen()) openTimer = setTimeout(function () { setOpen(true); }, 120);
  });
  root.addEventListener('mouseleave', function () {
    if (noHover) return;
    clearTimeout(openTimer);
    if (isOpen()) closeTimer = setTimeout(function () { setOpen(false); }, 250);
  });

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!isOpen());
    });
  }
  if (link) {
    link.addEventListener('click', function (e) {
      if (noHover && !isOpen()) { e.preventDefault(); setOpen(true); }
    });
  }

  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) {
      setOpen(false);
      if (toggle) toggle.focus();
    }
  });
  root.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !root.contains(e.relatedTarget)) setOpen(false);
  });
  document.addEventListener('click', function (e) {
    if (isOpen() && !root.contains(e.target)) setOpen(false);
  });
})();
